
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsShopGroupDialog extends Serenity.EntityDialog<PsShopGroupRow, any> {
        protected getFormKey() { return PsShopGroupForm.formKey; }
        protected getIdProperty() { return PsShopGroupRow.idProperty; }
        protected getLocalTextPrefix() { return PsShopGroupRow.localTextPrefix; }
        protected getNameProperty() { return PsShopGroupRow.nameProperty; }
        protected getService() { return PsShopGroupService.baseUrl; }
        protected getDeletePermission() { return PsShopGroupRow.deletePermission; }
        protected getInsertPermission() { return PsShopGroupRow.insertPermission; }
        protected getUpdatePermission() { return PsShopGroupRow.updatePermission; }

        protected form = new PsShopGroupForm(this.idPrefix);

        protected afterLoadEntity() {
            super.afterLoadEntity();

            var Shopgroupid = Q.tryFirst(PsShopRow.getLookup().items,x => x.ShopGroupId == this.entity.ShopGroupId);

            if(Shopgroupid != null){
                this.deleteButton.toggleClass('disabled', true);
                
            }
        }

       
    }
}